import { render, staticRenderFns } from "./CustomerPrice.vue?vue&type=template&id=0b11405e&scoped=true&"
import script from "./CustomerPrice.vue?vue&type=script&lang=js&"
export * from "./CustomerPrice.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPrice.vue?vue&type=style&index=0&id=0b11405e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b11405e",
  null
  
)

export default component.exports